<script setup lang="ts">
import NumberCounter from '@/uiKit/NumberCounter.vue'
import { twMerge } from 'tailwind-merge'

defineProps<{ count?: number }>()
</script>

<template>
  <h1 :class="twMerge('flex gap-1 text-display-sm-24px-default', String($attrs.class || ''))">
    <slot />

    <span
      v-if="count"
      class="text-sm-12px-default text-text-warning"
    >
      <NumberCounter :value="count" />
    </span>
  </h1>
</template>
